import Colors from '../../../styles/colors';

const buttonStyleBase = {
    height: 40,
    borderRadius: 5,
    padding: '6px 24px',
    margin: '4px 8px 4px 0',
    minWidth: 64,
    boxSizing: 'border-box',
    justifyContent: 'center',
};

const buttonStyleLabelBase = {
    fontWeight: 700,
    textTransform: 'none',
    fontSize: '0.9375rem',
    lineHeight: '19px',
};

const styles = (theme) => ({
    hideRadioIcon: {
        padding: 0,
        opacity: 0,
        width: 0,
        height: 0,
    },
    radioButton: {
        color: Colors.darkGrey,
    },
    'radioButton-buttonStyle': {
        ...buttonStyleBase,
        border: `1px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        '&:hover, &:focus-within:hover': {
            backgroundColor: Colors.white,
            boxShadow: '0 5px 15px 0 rgba(0,0,0,0.2)',
        },
        '&:focus-within': {
            backgroundColor: Colors.white,
            borderWidth: 3,
        },
    },
    radioButtonChecked: {
        color: theme.palette.primary.light,
    },
    'radioButtonChecked-buttonStyle': {
        ...buttonStyleBase,
        border: 0,
        backgroundColor: theme.palette.primary.main,
        '&:hover, &:focus-within:hover, &:focus': {
            backgroundColor: theme.palette.primary.light,
            boxShadow: '0 5px 15px 0 rgba(0,0,0,0.2)',
            border: 0,
        },
        '&:focus-within': {
            backgroundColor: theme.palette.primary.main,
            borderColor: theme.palette.primary.light,
            borderWidth: 3,
        },
    },
    'radioButtonDisabled-buttonStyle': {
        ...buttonStyleBase,
        backgroundColor: Colors.white,
        border: `1px solid rgba(${Colors.persianBlueRGB}, .3)`,
    },
    'radioButtonCheckedDisabled-buttonStyle': {
        ...buttonStyleBase,
        backgroundColor: theme.palette.primary.main,
        border: `1px solid rgba(${Colors.persianBlueRGB}, .3)`,
        opacity: 0.3,
    },
    'radioButtonLabel-buttonStyle': {
        ...buttonStyleLabelBase,
        color: theme.palette.primary.main,
    },
    'radioButtonLabelChecked-buttonStyle': {
        ...buttonStyleLabelBase,
        color: Colors.white,
    },
    'radioButtonLabelDisabled-buttonStyle': {
        ...buttonStyleLabelBase,
        color: theme.palette.primary.main,
        '&.Mui-disabled': {
            color: `rgba(${Colors.persianBlueRGB}, .3)`,
        },
    },
    'radioButtonLabelCheckedDisabled-buttonStyle': {
        ...buttonStyleLabelBase,
        color: theme.palette.primary.main,
        '&.Mui-disabled': {
            color: Colors.white,
        },
    },
});

export default styles;
